import { PdfRect } from './pdf';

export class GCalc {
  public static normalizeAngle(degrees: number): number {
    degrees = degrees % 360;
    if (degrees < 0) degrees += 360;
    return degrees;
  }

  public static centerRect(rect: PdfRect): PdfRect {
    const sz = Math.min(rect.width, rect.height);
    return new PdfRect(rect.x + (rect.width - sz) / 2, rect.y + (rect.height - sz) / 2, sz, sz);
  }
}
